<template>
  <div>
    <div class="box news-box" >
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>政策法规</el-breadcrumb-item>
          
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl">
          <div :class="activeIndex == 1 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'" @click="tab(1)">
            <div class="left-box-title-main">
              <img src="../../assets/images/s.png" alt />
              <span>国家政策</span>
            </div>
            <img  class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div :class="activeIndex == 2 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'" @click="tab(2)">
            <div class="left-box-title-main">
              <img src="../../assets/images/xz.png" alt />
              <span>法律法规</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div :class="activeIndex == 3 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'" @click="tab(3)">
            <div class="left-box-title-main">
              <img src="../../assets/images/r.png" alt />
              <span>省政策办法</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div :class="activeIndex == 4 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'" @click="tab(4)">
            <div class="left-box-title-main">
              <img  src="../../assets/images/sthj.png" alt />
              <span>行业标准规范</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
        </div>
        <div class="right-box fn-box fr">
          <ul>
            <li
              @click="handelTurnDetail(item)"
              class="normal"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <div>
                <span class="fl" :title="item.title">{{item.title}}</span>
                <span class="fr">
                  <span class="source" >{{item.source}}</span>
                  <span>{{item.publishTime | dateFormat}}</span>
                </span>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="query.current"
              :page-sizes="[10, 20, 50, 100,500]"
              :page-size="query.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import { getRegulationsPage } from "../../api/index";
export default {
  name: "",
  data() {
    return {
      query: {
        current: 1,
        size: 10,
        title: "",
        type:1
      },
      fullHeight: document.documentElement.clientHeight,
      page: {
        total: 0
      },
      tableData: [],
      activeIndex:1
    };
  },
  created() {
    this.getData();
  },
  filters: {
			//将时间戳过滤为正常日期格式
			dateFormat: function (data) {
        if(!data){
          return;
        }
			  var date = new Date(data.replace(/-/g,"/")).Format("yyyy-MM-dd");
			  return date;
			}
	},
  methods: {
    tab(type){
        this.activeIndex = type;
        this.query={
            current: 1,
            size: 10,
            title: "",
            type:type
        }
        this.getData();
    },
    getData() {
      getRegulationsPage(this.query).then(res => {
        this.tableData = res.data.records;
        this.page.total = res.data.total || 0;
      });
    },
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.getData();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.getData();
    },
    handelTurnDetail(row) {
      this.$router.push({
        path: "/policiesAndRegulationsDetail/" + row.id
      });
    }
  }
};
</script>

<style lang="" >
</style>


// WEBPACK FOOTER //
// src/views/policiesAndRegulations/index.vue